import { connect } from 'react-redux';
import {
  getFieldOfficeById,
  getCustomers,
  getCustomerDetail,
  getAccountInfo,
  getServiceOrder,
  updateCustomer,
  updateNotificationById,
  updateCard,
  deleteCard,
  addNewCard,
  getBlockList,
  addBlockUser,
  deleteBlockUser,
  getAccountNotes,
  addAccountNotes,
  getCardList,
  getNotificationById,
  getAuthorizedUserList,
  addAuthorizedUser,
  deleteAuthorizedUser,
  getCallLogList,
  addCallLog,
  getPricingHistory,
  viewService,
  getPauseService,
  pauseService,
  updatePauseService,
  getPauseReason,
  deletePauseService,
  editService,
  getPets,
  addPet,
  updatePet,
  deletePet,
  getFranchiseById,
  getCSVData,
  sendEmailReminder,
  getServiceOrderById,
  getInvoiceList,
  getInvoiceCreditMemoList,
  addPaymentLog,
  addManualPaymentLog,
  deletePaymentLog,
  getInvoiceById,
  getServiceOrderNumberList,
  getInvoiceSummary,
  resendInvoice,
  printInvoices,
  addInvoice,
  addManualInvoice,
  editInvoice,
  deleteInvoice,
  addInvoiceLineItem,
  editInvoiceLineItem,
  deleteInvoiceLineItem,
  getInvoiceDescription,
  getWorkOrderTypeDescription,
  finalizeInvoice,
  getPaymentHistory,
  getPaymentHistoryNew,
  getLastThreePayment,
  getStaffUsers,
  pricingCalculator,
  resetCheckZipcode,
  resetPricingCalculator,
  getServiceOrderEnquiry,
  updateServiceOrderEnquiry,
  checkZipCode,
  addServiceOrder,
  updateServiceOrder,
  exportPDFStatement,
  getAccountListing,
  getFieldTechnicianList,
  getServiceHistory,
  refundPayment,
  getSalesTax,
  suspendAccount,
  updatePartialServiceOrder,
  addUnattachedPayment,

  //Customer Ticket Module @codal-jsojitra
  getAllMessages,
  getUserList,
  getGroupList,
  createNewTickets,
  MessageReplies,
  UpdateTickets,
  readTickets,
  getMessagesCount,
  getGeocodeAddress, 
  resetGeocodeAddress,
  getServiceOrderFilter,
  getWorkOrderFilter,
  getFieldTechnicianFilter,
  getWorkOrderList,
  getWorkOrderDetail,
  deactivateServiceOrder,
  getRepresentativeList,
  updateCallLog,
  validateCoupon,
  addCreditMemo,
  addCreditMemoLineItem,
  voidInvoice,
  getCreditMemoDetails,
  lastThreeCreditMemo,
  postPaymentLog,
  cleanPaymentResponse,
  remainingCreditBalance,
  deleteAccountInvoice,
  invoiceProcess,
  addStaxPaymentInfo,
  getReasonList
} from '../../../../Action';
import CustomerDetail from "../Component/CustomerDetail";

const mapStateToProps = (state) => {
  const {
    ZipcodeCheck,
    CustomerList,
    ServiceOrder,
    UpdateNotification,
    UpdateCard,
    DeleteCard,
    AddCard,
    BlockList,
    AccountNotes,
    CardList,
    NotificationList,
    AuthorizedUser,
    CallLog,
    PricingHistory,
    Service,
    Pet,
    EmailReminder,
    Invoice,
    InvoiceCreditMemoList,
    PaymentHistory,
    // PaymentHistoryNew,
    LastThreePayment,
    PDFExportStatement,
    GetAccountList,
    GetManualy,
    PricingCalc,
    ServiceOrderEnquiry,
    InvoiceDescription,
    WorkOrderTypeDescription,
    FieldTechnician,

    //Customer Ticket @codal-jsojitra
    AllMessages,
    UserList,
    GroupList,
    NewTicket,
    RepliesonTicket,
    UpdateMesssage,
    MessageCount,
    GoogleApi,
    ServiceOrderFilter,
    WorkOrderFilter,
    FieldTechnicianFilter,
    WorkOrderList,
    WorkOrderDetail,
    deactivatedServiceOrder,
    RepresentativeList,
    ValidateCouponCode,
    VoidInvoice,
    AddPaymentLog,
    PostPaymentLog,
    RemainingCreditBalance,
    DeleteInvoice,
    InvoiceProcess,
    AddStaxInfo,
    getReasons
  } = state;

  return {
    ZipcodeCheck,
    CustomerList,
    ServiceOrder,
    UpdateNotification,
    UpdateCard,
    DeleteCard,
    AddCard,
    BlockList,
    AccountNotes,
    CardList,
    NotificationList,
    AuthorizedUser,
    CallLog,
    PricingHistory,
    Service,
    Pet,
    EmailReminder,
    Invoice,
    InvoiceCreditMemoList,
    PaymentHistory,
    // PaymentHistoryNew,
    LastThreePayment,
    PDFExportStatement,
    GetAccountList,
    GetManualy,
    PricingCalc,
    ServiceOrderEnquiry,
    InvoiceDescription,
    WorkOrderTypeDescription,
    FieldTechnician,
    //Customer Ticket Code by @codal-jsojitra
    AllMessages,
    UserList,
    GroupList,
    NewTicket,
    RepliesonTicket,
    UpdateMesssage,
    MessageCount,
    GoogleApi,
    ServiceOrderFilter,
    WorkOrderFilter,
    FieldTechnicianFilter,
    WorkOrderList,
    WorkOrderDetail,
    deactivatedServiceOrder,
    RepresentativeList,
    ValidateCouponCode,
    VoidInvoice,
    AddPaymentLog,
    PostPaymentLog,
    RemainingCreditBalance,
    DeleteInvoice,
    InvoiceProcess,
    AddStaxInfo,
    getReasons
  }
}

const actionCreators = {
  getFieldOfficeById,
  getCustomers,
  getCustomerDetail,
  getAccountInfo,
  getServiceOrder,
  updateCustomer,
  updateNotificationById,
  updateCard,
  deleteCard,
  addNewCard,
  getBlockList,
  addBlockUser,
  deleteBlockUser,
  getAccountNotes,
  addAccountNotes,
  getCardList,
  getNotificationById,
  getAuthorizedUserList,
  addAuthorizedUser,
  deleteAuthorizedUser,
  getCallLogList,
  addCallLog,
  getPricingHistory,
  viewService,
  getPauseService,
  pauseService,
  updatePauseService,
  getPauseReason,
  deletePauseService,
  editService,
  getPets,
  addPet,
  updatePet,
  deletePet,
  sendEmailReminder,
  getFranchiseById,
  getServiceOrderById,
  getInvoiceList, // invoice
  getInvoiceCreditMemoList,
  finalizeInvoice,
  getInvoiceById,
  getServiceOrderNumberList,
  getInvoiceSummary,
  resendInvoice,
  printInvoices,
  addInvoice,
  addManualInvoice,
  editInvoice,
  deleteInvoice,
  addPaymentLog,
  addManualPaymentLog,
  deletePaymentLog,
  addInvoiceLineItem,
  editInvoiceLineItem,
  deleteInvoiceLineItem,
  getInvoiceDescription,
  getWorkOrderTypeDescription,
  getStaffUsers,
  exportPDFStatement,
  getPaymentHistory,
  getPaymentHistoryNew,
  getLastThreePayment,
  refundPayment,
  getSalesTax,
  getAccountListing,
  pricingCalculator,
  resetCheckZipcode,
  resetPricingCalculator,
  getServiceOrderEnquiry,
  updateServiceOrderEnquiry,
  checkZipCode,
  addServiceOrder,
  updateServiceOrder,
  updatePartialServiceOrder,
  getFieldTechnicianList,
  getServiceHistory,
  suspendAccount,
  //Customer Ticket @codal-jsojitra
  getAllMessages,
  getUserList,
  getCSVData,
  getGroupList,
  createNewTickets,
  MessageReplies,
  UpdateTickets,
  readTickets,
  getMessagesCount,
  getGeocodeAddress,
  resetGeocodeAddress,
  getServiceOrderFilter,
  getWorkOrderFilter,
  getFieldTechnicianFilter,
  getWorkOrderList,
  getWorkOrderDetail,
  deactivateServiceOrder,
  getRepresentativeList,
  updateCallLog,
  validateCoupon,
  voidInvoice,
  addCreditMemo,
  addCreditMemoLineItem,
  getCreditMemoDetails,
  lastThreeCreditMemo,
  addUnattachedPayment,
  postPaymentLog,
  cleanPaymentResponse,
  remainingCreditBalance,
  deleteAccountInvoice,
  invoiceProcess,
  addStaxPaymentInfo,
  getReasonList
}
export default (connect(mapStateToProps, actionCreators)(CustomerDetail));
